var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedcross(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3746 8.7065e-05C33.1793 8.7065e-05 42.7491 9.5582 42.7491 21.3487C42.7491 33.1391 33.1793 42.6972 21.3746 42.6972C9.5698 42.6972 8.86587e-05 33.1391 8.86587e-05 21.3487C-0.0335011 9.59163 9.4817 0.0336361 21.2529 8.7065e-05C21.2934 -2.90217e-05 21.334 -2.90217e-05 21.3746 8.7065e-05Z",
    fill: "#BC4141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6819 15.3963L15.5012 30.5586L11 28L27.2208 12L30.6819 15.3963Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3963 12.3181L30.5586 27.4988L28 32L12 15.7792L15.3963 12.3181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedcross);
export default __webpack_public_path__ + "static/media/redcross.dde625de9e6b7798c52bcf60420e87c9.svg";
export { ForwardRef as ReactComponent };